<template>
    <div class="container is-fluid">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <Nav style="margin-bottom: 20px;" />
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12" style="margin-top: 70px;">
                    <template>
                        <div class="level">

                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-icon">
                                    <b-icon icon="view-compact"></b-icon>
                                </div>
                                <div class="level-item">
                                    <h4 class="title is-4">{{ $route.name }}</h4>
                                </div>
                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                            </div>
                        </div>
                    </template>
                    <template>
                        <div class="columns box">
                            <div class="column is-4 has-background-white-ter">
                                <div class="buttons">
                                    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
                                        <modal-form v-bind="formProps"></modal-form>
                                    </b-modal>
                                </div>
                                <div class="card events-card">
                                    <div class="card-table">
                                        <div class="content">
                                            <table class="table is-fullwidth is-striped">
                                                <tbody>
                                                    <tr v-for="mail in mails" v-bind:key="mail.date">
                                                        <td>{{ mail.subject }}</td>
                                                        <td class="level-right">
                                                            <b-button type="is-primary" v-on:click="SetHtml($event,mail.text)">View</b-button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-8">
                                <div contenteditable="true" v-html="mailHtml"></div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
    import Nav from '@/components/Nav.vue'
       import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

const ModalForm = {
  props: ['email', 'password'],
  template: `
        <div class="modal-card" style="width: 520px">
            <header class="modal-card-head">
                <p class="modal-card-title">Login</p>
                <b-field>
                    <b-select placeholder="Select a name">
                        <option
                            v-for="option in data"
                            :value="option.id"
                            :key="option.id">
                            {{ option.user.first_name }}
                        </option>
                    </b-select>
                </b-field>
            </header>
            <section class="modal-card-body">
                <b-field label="Email">
                    <b-input
                        type="email"
                        :value="email"
                        placeholder="Your email"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Password">
                    <b-input
                        type="password"
                        :value="password"
                        password-reveal
                        placeholder="Your password"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Message">
                    <b-input maxlength="200" type="textarea"></b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary">Login</button>
            </footer>
        </div>
    `}
export default {
  components: {
    Nav,
    ModalForm,
    Loading
  },
  data() {
    return {
      mails: [],
      isBusy: false,
      mailHtml: '',
      isComponentModalActive: false,
      formProps: {
        email: 'evan@you.com',
        password: 'testing',
      },
    }
        },
        created() {
            const self = this;
            this.$store.dispatch('verifyAccess').then(() => {
                self.LoadEmails();
            });

  },
  methods: {
    SetHtml(evento, html) {
      //Se marca solo el mail al que se le dio clic como activo
      const objects = document.getElementsByClassName('item-email')
      for (let i = 0; i < objects.length; i++) {
        objects[i].className = 'item-email list-item'
      }

      event.target.className = 'item-email list-item is-active'

      //Se asigna el contenido del mail al innerHTML del div.
      this.mailHtml = html
    },
    LoadEmails() {
      //Se hace la petición REST encargada de obtener los EMAIL.
        this.isBusy = true;
        const self = this
        this.$store.dispatch('getEmails').then(response => {
            const genericResponse = response.data;

            if (genericResponse.isError == true) {
                this.$buefy.notification.open({
                    message: `Error: ${genericResponse.messageError}`,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true,
                })
                self.isBusy = false;
                return;
            }
            self.mails = genericResponse.result;
            self.isBusy = false;
        }).catch(error => {
            this.$buefy.notification.open({
                    message: `Error: ${error.message}`,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true,
            })
            self.isBusy = false;
        });
    },
  },
}
</script>
<style lang="scss" scope>

    .card .content {
        font-size: 14px;
    }

    .card-footer-item {
        font-size: 14px;
        font-weight: 700;
        color: #8f99a3;
    }

    .card-table .table {
        margin-bottom: 0;
    }

    .events-card .card-table {
        max-height: 250px;
        overflow-y: scroll;
    }
</style>
